import { useAuth } from "@/context/AuthContext";

export const MANAGER = "kqm_manager";
export const ROLE_LABELS = { kqm_admin: "Admin", kqm_manager: "Manager", amden_super: "Super Admin", employee: "Staff", system: "System" };
export const roleLabel = (r) => ROLE_LABELS[r] || r;
export const useIsManager = () => useAuth().user?.role === MANAGER;
